module Parser
open System
open Feliz
open RenderHelpers

// tekststring
// met linebreaks
// eerst splisen in lines

// optie monofont en proportoineel

type Formatter = {
    FontFamily : string
    TextWeight : string
    Size : string
    BgColor : string
    FgColor : string
}

let formatter2Classes formatter =
    "my-0 " +
    formatter.FontFamily + " " +
    formatter.TextWeight + " " +
    formatter.Size  + " " +
    formatter.BgColor  + " " +
    formatter.FgColor

let create () =    {
        FontFamily = "is-family-sans-serif"
        TextWeight = "has-text-weight-normal"
        Size = "is-size-5"
        BgColor = "has-background-white"
        FgColor = "has-text-black"}

let isBlockCommand (line:string) =
    line.Trim()
    |> fun s -> s.StartsWith(":")

let applyCommand (command:string) formatter =
    match command.ToLower() with
        | "prop" -> {formatter with FontFamily = "is-family-sans-serif"}
        | "mono" -> {formatter with FontFamily = "is-family-monospace"}
        | "dark" -> {formatter with BgColor = "has-background-dark"; FgColor="has-text-light"}
        | "light" -> {formatter with BgColor = "has-background-white"; FgColor="has-text-black"}
        | "black" -> {formatter with FgColor="has-text-black"}
        | "white" -> {formatter with FgColor="has-text-white"}
        | "red" -> {formatter with FgColor="has-text-danger"}
        | "green" -> {formatter with FgColor="has-text-success"}
        | "yellow" -> {formatter with FgColor="has-text-warning"}
        | "blue" -> {formatter with FgColor="has-text-link"}
        | "lightblue" -> {formatter with FgColor="has-text-info"}
        | "bold" -> {formatter with TextWeight="has-text-weight-bold"}
        | "normal" -> {formatter with TextWeight="has-text-weight-normal"}
        //|  s when s.Length>5 && s.Substring(0,4)="size" -> {formatter with Size = "is-size-" + s.Substring(5,1)}
        |  s when s.Length=1 -> {formatter with Size = "is-size-" + s}
        | _ ->
            formatter


let parseBlockCommand (line:string) (formatter:Formatter) =
    line.Replace(" ", "")
    |> fun s -> s.Substring(1)
    |> fun s -> formatter,s.Split(':')
    ||> Array.fold (fun state input -> applyCommand input state)

let isLineCommand (line:string) =
    line.Trim()
    |> fun s -> s.StartsWith("<:")


let parseLineCommand  (line:string) (formatter:Formatter) =
    line.Replace(" ", "")
    |> fun s -> s.Substring(2)
    |> fun s ->
        let pos= s.IndexOf(":>")
        s.Substring(0,pos)
    |> fun s -> formatter,s.Split(':')
    ||> Array.fold (fun state input -> applyCommand input state)
    |> fun f -> f, line.Substring(line.IndexOf(":>")+2)

let str2Formatted  (str:string) =
    let mutable formatter = create()

    let makep (line:string) formatter=
        Html.p [
            prop.className (formatter2Classes formatter)
            prop.text line]

    str.Split('\n')
    |> Array.map (fun line ->
        match line with
        | "" -> wrap1In Html.div formatter.BgColor (Html.br [])
        | s when isBlockCommand s ->
            formatter <- parseBlockCommand s formatter
            Html.none
        | s when isLineCommand s ->
            let lineFormatter, newline = parseLineCommand s formatter
            makep newline lineFormatter
        | _ -> makep line formatter)
    |> Array.toList
    |> wrapxIn Html.div ""